import { render, staticRenderFns } from "./InsuranceScreen.vue?vue&type=template&id=3714b77a&scoped=true&"
import script from "./InsuranceScreen.vue?vue&type=script&lang=js&"
export * from "./InsuranceScreen.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceScreen.vue?vue&type=style&index=0&id=3714b77a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3714b77a",
  null
  
)

export default component.exports